import { Lock as LockIcon } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../components/Auth/AuthContext';

const messages = {
  transaction: {
    title: 'Demo Limit Reached',
    body: "You've added the maximum number of transactions in demo mode (3). Sign up for free to track unlimited expenses, income, and investments.",
  },
  holding: {
    title: 'Demo Limit Reached',
    body: "You've added the maximum number of stock orders in demo mode (2). Sign up for free to track your full portfolio with unlimited holdings.",
  },
  category: {
    title: 'Demo Mode',
    body: 'Adding custom categories is not available in demo mode. Sign up for free to create your own categories and organize your finances your way.',
  },
  default: {
    title: 'Demo Limit Reached',
    body: 'This action is not available in demo mode. Sign up for free to unlock all features.',
  },
};

const DemoLimitDialog = ({ open, limitType, onClose }) => {
  const { exitDemoMode } = useContext(AuthContext);
  const navigate = useNavigate();

  const msg = messages[limitType] || messages.default;

  const handleSignUp = () => {
    onClose();
    exitDemoMode();
    navigate('/register');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ textAlign: 'center', pt: 4, pb: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
          <LockIcon sx={{ fontSize: 48, color: 'primary.main' }} />
          <Typography variant="h6" fontWeight={600}>{msg.title}</Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', pb: 1 }}>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
          {msg.body}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ flexDirection: 'column', gap: 1, px: 3, pb: 3 }}>
        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={handleSignUp}
          sx={{ borderRadius: 2, py: 1.2 }}
        >
          Create Free Account
        </Button>
        <Button
          variant="text"
          fullWidth
          onClick={onClose}
          sx={{ color: 'text.secondary' }}
        >
          Continue Exploring
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DemoLimitDialog;
